import React from 'react'

import styles from "../Portfolio/Portfolio.module.css"
import Typewriter from "typewriter-effect";
import profilepic from "../Images/IMG_192_9_copy.jpg"
import Button from '@material-ui/core/Button';
const Portfolio = () => {

    const buttonStyle = {
        width: "40%",
        maxHeight: "40px",
        fontWeight: "bold",
        margin: "10% 0 0 50%"
    };


    const handleButtonClick = () => {
        const newTab = window.open("https://drive.google.com/file/d/11xMHMopjYo5Gm_FCDKZmlkOxrCrom6WO/view", '_blank');

        setTimeout(() => {
            const downloadLink = document.createElement('a');
            downloadLink.href = "https://gdurl.com/7I3FJ/download";
            downloadLink.download = "abhishek_chauhan_fw11-306.jpg";

            document.body.appendChild(downloadLink);
            downloadLink.click();

            document.body.removeChild(downloadLink);
        }, 100);
    };

    const newTab = (url) => {
        const newWindow = window.open(url, '_blank', 'noopener,noreferrer')
        if (newWindow) newWindow.opener = null
    }

    return (
        <div className={styles.aboutContainer}>

            <div id="home" className={styles.contain}>
                <div className={styles.badge}>
                    <img style={{ width: "100%", height: "100%" }} alt="Abhishek Chauhan" src={profilepic} />
                </div>
                <div>
                    <div className={styles.name}>
                        <h1>Abhishek Chauhan</h1>
                    </div>
                    <div className={styles.typebox}>
                        <h2>
                            <Typewriter
                                options={{
                                    autoStart: true,
                                    loop: true,
                                }}
                                onInit={(typewriter, options) => {

                                    typewriter
                                        .typeString("Full Stack Developer")
                                        .pauseFor(1000)
                                        .deleteAll()
                                        .start();
                                }}
                            />
                        </h2>
                    </div>

                    <div >
                        <Button className= "download-resume-button"
                            variant="contained"
                            color="secondary"
                            style = {buttonStyle}
                            onClick={handleButtonClick}
                        >
                            <p className="download-resume">Resume</p>
                        </Button>
                    </div>
                </div>

            </div>
        </div>
    )
}

export { Portfolio }
